"use strict";

//import 'jquery'
import 'selectric/public/jquery.selectric'
import { isIE } from './utils/isIE'

if((window.devicePixelRatio || 1) > 2){
  $('body').addClass('high-device-pixel-ratio')
}

if(isIE()) {

  let ieHTML = $("#no-ie-support").html()
  $('body').html(ieHTML)

} else {

  require('./setup')
  require('./cookie')
  require('./locomotive-scroll')
  require('./popup')
  require('./popup-video')
  require('./popup-methodology')
  require('./blocks/intro')
  require('./blocks/about')
  require('./blocks/partners')
  require('./blocks/news')
  require('./blocks/rankings-top-five')
  require('./partials/news/categories-filter')
  require('./fbq')
  require('./menu')

}




